var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('transition',{attrs:{"name":"page-fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }